import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";
import { trips } from "../../../../../../redux/trips/action";
import { selectTripsListItems } from "../../../../../../redux/trips/selector";
import { selectListItems } from "../../../../../../redux/library/selector";
import { agentStatus } from "../../../../../../redux/agent-status/action";
import MobileViewTable from "../../../../../../common/components/mobile-view-table.component";
import { paymentStatus } from "../../../../../../redux/payment-status/action";
import storePersist from "../../../../../../redux/storePersist";
import _ from "lodash";
import { selectAgentStatusUpdatedItem } from "../../../../../../redux/agent-status/selector";
import { toast } from "react-toastify";
import { selectPaymentStatusUpdatedItem } from "../../../../../../redux/payment-status/selector";

const TransportAgentTripsMobile = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const libraryData = useSelector(selectListItems)
    const PaymentUpdateStatus = useSelector(selectPaymentStatusUpdatedItem)
    const [index, setIndex] = useState(1)
    const [hasMore, setHasMore] = useState();
    const itemsData = useSelector(selectTripsListItems)
    const [rawData, setRawData] = useState<any>([])
    const [tripData, setTripData] = useState<any>([])
    const updateStatus = useSelector(selectAgentStatusUpdatedItem)
    const [
        columnDefs,
        setColumnDefs
    ] = useState({});
    const roleData = _.find(storePersist.get('userProfile')?.current?.items[0]?.Message?.Roles, ['Name', 'TransportAgent']);

    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(
                        params.node.id,
                        10
                    ) + 1;
                },
            },
            { field: 'ShipmentId', headerName: 'Order Id', search: true },
            { field: `StartLocation`, headerName: 'Pickup Address', isAddressFormat: true },
            { field: `EndLocation`, headerName: 'Drop Address', isAddressFormat: true },
            { field: `fulfillments[0].vehicle.vehicleName`, headerName: 'VehicleType' },
            {
                field: 'PaymentMethodId',
                headerName: 'Payment Method',
                cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.PaymentMethod },
                isRowColorDecider: true,
                sortable: true,
                filter: false
            },

            {
                field: `CargoTripsStatusId`, headerName: 'Trip status', cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.CargoTripsStatus }, isRowColorDecider: true
            },
            {
                field: `CargoOrderStatusId`, headerName: 'Order Status', cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.CargoOrderStatus }, isRowColorDecider: true
            },
            {
                field: `CargoTransportAgentStatusId`, headerName: 'Driver Status', cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.CargoTransportAgentStatus }, isCargoDriverEditable: true, isRowColorDecider: true
            },
            {
                field: `CargoPickupStatusId`, headerName: 'Pickup Status', cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.CargoPickupStatus }, isCargoPickupEditable: true, isRowColorDecider: true
            },
            {
                field: `CargoExceptionOrIssuesStatusId`, headerName: 'Exceptions/Issues Status', cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.CargoExceptionOrIssuesStatus }, isCargoIssuesEditable: true, isRowColorDecider: true
            },
            {
                field: `CargoTransitStatusId`, headerName: 'Transit Status', cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.CargoTransitStatus }, isCargoTransitEditable: true, isRowColorDecider: true
            },
            {
                field: `CargoDeliveryStatusId`, headerName: 'Delivery Status', cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.CargoDeliveryStatus }, isCargoDeliveryEditable: true, isRowColorDecider: true
            },
            {
                field: 'PaymentStatusId',
                headerName: 'Payment Status',
                cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.PaymentStatus },
                isRowColorDecider: true,
                sortable: true,
                filter: false,
                isPaymentEditble: true
            },
            { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
            { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true },
        ]);
    }

    const handleEdit = (data: any) => {

        navigate(`${data?.Id}`)
    }

    const agentStatusToaster = async () => {
        await toast.error(`${updateStatus?.result?.Error?.message}`)
        await dispatch(agentStatus.resetAction({ actionType: 'update' }))
    }

    useEffect(() => {

        if (updateStatus?.result?.Error?.code == 400) {
            agentStatusToaster()
        }
    }, [updateStatus]);


    const handleSearch = async (data: any) => {

        const searchCriteria = [{
            FieldName: "ShipmentId",
            FieldText: "ShipmentId",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
        }]
        await setTripData([])
        await dispatch(trips.resetAction({ actionType: 'list' }))
        await dispatch(trips.list({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/trips/list`, entity: 'trips', jsonData: {
                "PageNumber": index,
                "PageSize": 10,
                "SortField": "Id",
                "SortOrder": "desc",
                "Searches": searchCriteria,
                "Filters": [
                    {
                        "FieldName": "TransportAgentId",
                        "FilterOperatorId": 1,
                        "FieldValue": roleData?.Id,
                        "FieldType": "number"
                    }]
            }
        }));
    }

    const fetchTrips = async (_page: any, size: any) => {
        await dispatch(trips.resetAction({ actionType: 'list' }))
        await dispatch(trips.list({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/trips/list`, entity: 'trips', jsonData: {
                "PageNumber": _page,
                "PageSize": size,
                "SortField": "ModifiedOnUtc",
                "SortOrder": "desc",
                "Filters": [
                    {
                        "FieldName": "TransportAgentId",
                        "FilterOperatorId": 1,
                        "FieldValue": roleData?.Id,
                        "FieldType": "number"
                    }]

            }
        }))
    }

    const handleDelete = async (data: any) => {
        await dispatch(trips.delete({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/trips/delete`,
            entity: 'trips',
            jsonData: {
                Context: {},
                Records: [
                    {
                        Id: data?.Id
                    }
                ]
            }
        }))
        await setTripData([])
        await fetchTrips(index, 10)
    }

    const handleCargoDriverStatusClick = async (event: any, dataId: any) => {
        await dispatch(agentStatus.resetAction({ actionType: 'update' }))
        await dispatch(agentStatus.update({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/transport-agents/agent-status`,
            entity: 'agentStatus',
            jsonData: {

                Context: {},
                Records: [
                    {
                        "Id": dataId?.fulfillments[0]?.agent?.id,
                        "TripsId": dataId?.Id,
                        "ShipmentId": dataId?.ShipmentId,
                        "CargoTransportAgentStatusId": event
                    }
                ]

            }
        }))
        await setTripData([])
        await fetchTrips(index, 10)
    };
    const handleCargoDeliveryStatusClick = async (event: any, dataId: any) => {
        await dispatch(agentStatus.resetAction({ actionType: 'update' }))
        await dispatch(agentStatus.update({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/transport-agents/delivery-status`,
            entity: 'agentStatus',
            jsonData: {

                Context: {},
                Records: [
                    {
                        "Id": dataId?.fulfillments[0]?.agent?.id,
                        "TripsId": dataId?.Id,
                        "ShipmentId": dataId?.ShipmentId,
                        "CargoDeliveryStatusId": event
                    }
                ]

            }
        }))
        await setTripData([])
        await fetchTrips(index, 10)
    };
    const handleCargoTransitStatusClick = async (event: any, dataId: any) => {
        await dispatch(agentStatus.resetAction({ actionType: 'update' }))
        await dispatch(agentStatus.update({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/transport-agents/transit-status`,
            entity: 'agentStatus',
            jsonData: {

                Context: {},
                Records: [
                    {
                        "Id": dataId?.fulfillments[0]?.agent?.id,
                        "TripsId": dataId?.Id,
                        "ShipmentId": dataId?.ShipmentId,
                        "CargoTransitStatusId": event
                    }
                ]

            }
        }))
        await setTripData([])
        await fetchTrips(index, 10)
    };
    const handleCargoIssueStatusClick = async (event: any, dataId: any) => {
        await dispatch(agentStatus.resetAction({ actionType: 'update' }))
        await dispatch(agentStatus.update({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/transport-agents/issue-status`,
            entity: 'agentStatus',
            jsonData: {

                Context: {},
                Records: [
                    {
                        "Id": dataId?.fulfillments[0]?.agent?.id,
                        "TripsId": dataId?.Id,
                        "ShipmentId": dataId?.ShipmentId,
                        "CargoExceptionOrIssuesStatusId": event
                    }
                ]

            }
        }))
        await setTripData([])
        await fetchTrips(index, 10)
    };
    const handleCargoPickupStatusClick = async (event: any, dataId: any) => {
        await dispatch(agentStatus.resetAction({ actionType: 'update' }))
        await dispatch(agentStatus.update({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/transport-agents/pickup-status`,
            entity: 'agentStatus',
            jsonData: {

                Context: {},
                Records: [
                    {
                        "Id": dataId?.fulfillments[0]?.agent?.id,
                        "TripsId": dataId?.Id,
                        "ShipmentId": dataId?.ShipmentId,
                        "CargoPickupStatusId": event
                    }
                ]

            }
        }))
        await setTripData([])
        await fetchTrips(index, 10)

    };
    const handlePaymentStatusClick = async (paymentValue: any, dataId: any) => {
        await dispatch(paymentStatus.resetAction({ actionType: 'update' }))
        await dispatch(paymentStatus.update({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/shipments/payment-status`,
            entity: 'paymentStatus', options: { notifyOnSuccess: false, notifyOnFailed: true },
            jsonData: {


                Records: [
                    {
                        context: {},
                        Message: {
                            ShipmentId: dataId?.ShipmentId,
                            PaymentStatusId: paymentValue?.PaymentStatusId,
                            PaidAmount: paymentValue?.PaidAmount
                        }
                    }
                ]


            }
        }))
        await setTripData([])
        await fetchTrips(index, 10)
    }
    const PaymentStatusToaster = async () => {
        await toast.error(PaymentUpdateStatus?.result?.Records[0]?.Error?.Message)
        await dispatch(paymentStatus.resetAction({ actionType: 'update' }))
    }

    useEffect(() => {
        if (PaymentUpdateStatus?.result?.Records[0]?.Error) {
            PaymentStatusToaster()
        }
    }, [PaymentUpdateStatus]);

    useEffect(() => {
        createColumnDefs()
        fetchTrips(index, 10)
    }, [])

    useEffect(() => {
        if (index > 1) {
            createColumnDefs()
            fetchTrips(index, 10)
        }

    }, [index])

    const fetchMoreData = () => {
        const prevIndex = index
        setIndex(prevIndex + 1);
    };
    useEffect(() => {
        if (itemsData?.result?.items) {
            setRawData(itemsData?.result?.items)
            setHasMore(itemsData?.result?.pagination?.HasNextPage)
        }
    }, [itemsData]);

    useEffect(() => {
        let formatedData = []
        rawData.map((data: any) => {
            formatedData.push({
                Id: data?.Id,
                BalanceAmount: data?.BalanceAmount,
                StartLocation: data?.fulfillments[0].start.location,
                EndLocation: data?.fulfillments[0].end.location,
                VehicleType: data?.fulfillments[0].vehicle.vehicleType,
                PaymentMethodId: data?.PaymentMethodId,
                PaymentStatusId: data?.PaymentStatusId,
                CargoTripsStatusId: data?.CargoTripsStatusId,
                CargoOrderStatusId: data?.CargoOrderStatusId,
                CargoTransportAgentStatusId: data?.CargoTransportAgentStatusId,
                CargoPickupStatusId: data?.CargoPickupStatusId,
                CargoExceptionOrIssuesStatusId: data?.CargoExceptionOrIssuesStatusId,
                CargoTransitStatusId: data?.CargoTransitStatusId,
                CargoDeliveryStatusId: data?.CargoDeliveryStatusId,
                ShipmentId: data?.ShipmentId,
                OrderTotal: data?.OrderTotal,
                fulfillments: data?.fulfillments,
                CreatedOnUtc: data?.CreatedOnUtc,
                ModifiedOnUtc: data?.ModifiedOnUtc,

            })
        })
        if (index > 1) {
            setTripData([...tripData, ...formatedData])
        } else {
            setTripData(formatedData)
        }

    }, [rawData])

    const additionButtons: any = [

        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
                    <title>Reload Jobs</title>
                    <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>,
            callback: () => handlereload(),
        }
    ];

    const handlereload = async () => {
        await setTripData([])
        await fetchTrips(index, 10)
    }

    return (
        <>
            {itemsData?.isLoading && index == 1 ? <PageLoader />
                :
                <MobileViewTable
                    onSearch={handleSearch}
                    dataLength={tripData.length}
                    fetchMoreData={fetchMoreData}
                    hasMore={hasMore}
                    additionButtons={additionButtons}
                    columnData={columnDefs}
                    rowData={tripData}
                    onCargoDriverStatusClick={handleCargoDriverStatusClick}
                    onCargoDeliveryStatusClick={handleCargoDeliveryStatusClick}
                    onCargoTransitStatusClick={handleCargoTransitStatusClick}
                    onCargoIssueStatusClick={handleCargoIssueStatusClick}
                    onCargoPickupStatusClick={handleCargoPickupStatusClick}
                    onPaymentStatusClick={handlePaymentStatusClick}
                    onEdit={handleEdit}
                    onDelete={handleDelete}
                    headingName="Trips" />

            }
        </>

    );
};

export default TransportAgentTripsMobile;


